<template>
  <div class="home">
    <div class="banner">
      <van-swipe :autoplay="3000">
        <van-swipe-item
          v-for="(item, index) in banner"
          :key="index"
        >
          <a
            v-if="item.link"
            class="banner_img"
            :href="item.link"
            target="_blank"
            aria-label
          >
            <img
              :src="item.image"
              alt="banner"
            >
          </a>
          <a
            v-else
            class="banner_img"
            aria-label
          >
            <img
              :src="item.image"
              alt="banner"
            >
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- <div class="upcoming">
      <h2 class="title primary_color">
        {{ $t('common.p58') }}
      </h2>
      <div class="line" />
      <div class="content">
        <template v-if="upcomingList.length === 0">
          <div class="con-item">
            <img
              class="image"
              src="/official_mobile/static/img/festival/europe.jpg"
              alt=""
            >
            <div class="con-p regular_color">
              <p class="subtitle primary_color">
                Europe
              </p>
              <p>{{ $t('common.p59') }}</p>
              <p>Jan - Dec, 2020</p>
            </div>
          </div>
          <div class="con-item">
            <img
              class="image"
              src="/official_mobile/static/img/festival/asia_pacific.jpg"
              alt=""
            >
            <div class="con-p regular_color">
              <p class="subtitle primary_color">
                Asia - Pacific
              </p>
              <p>{{ $t('common.p59') }}</p>
              <p>Jan - Dec, 2020</p>
            </div>
          </div>
          <div class="con-item">
            <img
              class="image"
              src="/official_mobile/static/img/festival/americas.jpg"
              alt=""
            >
            <div class="con-p regular_color">
              <p class="subtitle primary_color">
                Americas
              </p>
              <p>{{ $t('common.p59') }}</p>
              <p>Jan - Dec, 2020</p>
            </div>
          </div>
        </template>
        <div
          v-for="item in upcomingList"
          :key="item.id"
          class="con-item"
          @click="toFestivalUpcomingItem(item.id)"
        >
          <img
            class="image"
            :src="'/official_mobile/static/img/festival/flat/' + item.platform + '.jpg'"
            alt=""
          >
          <div class="con-p regular_color">
            <p class="subtitle primary_color">
              {{ item.title }}
            </p>
            <p>{{ $t('common.p75') }}: {{ item.startDate | format }} - {{ item.endDate | format }}</p>
            <p>{{ $t('common.p78') }}: {{ item.city }}</p>
            <p>{{ $t('common.p76') }}: {{ item.buyin }} </p>
          </div>
        </div>
      </div>
    </div> -->

    <div class="divider_color" />

    <div class="past_event">
      <h2 class="title primary_color">
        {{ $t('common.p60') }}
      </h2>
      <div class="line" />
      <div class="content">
        <div
          v-for="item in pasteventList"
          :key="item.id"
          class="con-item"
          @click="toFestivalItem(item.id)"
        >
          <img
            class="image"
            :src="item.headImage"
            alt=""
          >
          <div class="con-p">
            <p class="p1 primary_color">
              {{ item.title }}
            </p>
            <p class="p2 regular_color">
              {{ item.subtitle }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="divider_color" />

    <div class="about">
      <h2 class="title primary_color">
        {{ $t('common.p73') }}
      </h2>
      <div class="line" />
      <div class="content regular_color">
        <p>{{ $t('event.p4') }}</p>
        <p>{{ $t('event.p5') }}</p>
      </div>
    </div>

    <div class="divider_color" />
  </div>
</template>

<script>
// @ is an alias to /src
// import 'swiper/dist/css/swiper.css'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getFestivalBanner, getFestivalPreviewMatch, getFestivalHistoryMatch } from '@/api/official'
import moment from 'moment'

export default {
  filters: {
    format: function (date) {
      return moment(date).format('MMM Do, YYYY')
    }
  },
  components: {
    // swiper,
    // swiperSlide
  },
  data () {
    return {
      eventName: 'pastevent',
      upcomingList: [],
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      banner: [],
      pasteventList: []
    }
  },
  created () {
    this.$store.commit('changeTab', 1)
    this.initData()
  },
  methods: {
    initData () {
      getFestivalBanner()
        .then(res => {
          this.banner = res.data.list.map(v => {
            return {
              // style: {
              //   backgroundImage:
              //     'url(' + v.pcImage + ')'
              // },
              image: v.mobileImage,
              link: v.jumpUrl
            }
          })
        })
        .catch(err => {
          console.log(err)
        })

      getFestivalPreviewMatch()
        .then(res => {
          this.upcomingList = res.data.list.map(v => {
            return {
              ...v, title: v.lang[this.$i18n.locale]
            }
          })
        })
        .catch(err => {
          console.log(err)
        })

      getFestivalHistoryMatch()
        .then(res => {
          this.pasteventList = res.data.list.map(v => {
            return {
              ...v.lang[this.$i18n.locale], id: v.id, headImage: v.headImage
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    toFestivalUpcomingItem (item) {
      this.$router.push({ name: 'festival-upcoming', params: { index: item } })
    },
    toFestivalItem (item) {
      this.$router.push({ name: 'festival-past', params: { id: item } })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 0;
  .banner {
    position: relative;
    width: 100%;
    min-height: 416px;
    background-color: #000;
    .banner_img {
      display: block;
      width: 100%;
      min-height: 416px;
      img {
        width: 100%;
        display: block;
      }
    }
  }

  .upcoming {
    background-color: transparent;
    // border-width: 30px 0px 30px 0px;
    // border-style: solid;
    // border-image-slice: 30 0 30 0 fill;
    // border-image-repeat: stretched;
    // border-image-source: url('/official_mobile/static/img/bg/festival/2_event_festival/01.png');

    padding: 30px 24px 40px 24px;
    .title {
      font-size: 30px;
      margin: 10px 0px 40px 0px;
    }
    .content {
      font-size: 20px;
      // color: #999999;
      .to_be_announced {
        position: relative;
        .to_be_announced_p {
          position: absolute;
          width: 100%;
          height: 50px;
          left: 0px;
          top: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
        }
        img {
          display: inline-block;
          width: 100%;
        }
      }
      .con-item {
        padding: 22px 0px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        border-bottom: 2px solid #c0c0c0;
        .image {
          display: block;
          width: 188px;
        }
        .con-p {
          width: 480px;
          .subtitle {
            font-size: 28px;
          }
          p {
            font-size: 22px;
          }
        }
      }
    }
  }

  .past_event {
    background-color: transparent;
    // border-width: 30px 0px 30px 0px;
    // border-style: solid;
    // border-image-slice: 30 0 30 0 fill;
    // border-image-repeat: stretched;
    // border-image-source: url('/official_mobile/static/img/bg/festival/2_event_festival/02.png');

    padding: 30px 24px 40px 24px;
    .title {
      font-size: 30px;
      margin: 10px 0px 40px 0px;
    }
    .line {
      border-top: 2px solid #4d4646;
      margin-bottom: 10px;
    }
    .content {
      // font-size: 20px;
      .con-item {
        padding: 26px 0px 50px 0px;
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        border-bottom: 2px solid #c0c0c0;
        .image {
          display: block;
          width: 100%;
        }
        .con-p {
          margin-top: 20px;
          .p1 {
            font-size: 30px;
            line-height: 40px;
          }
          .p2 {
            font-size: 24px;
            line-height: 40px;
          }
        }
      }
    }
  }

  .about {
    background-color: transparent;
    // border-width: 30px 0px 30px 0px;
    // border-style: solid;
    // border-image-slice: 30 0 30 0 fill;
    // border-image-repeat: stretched;
    // border-image-source: url('/official_mobile/static/img/bg/festival/2_event_festival/03.png');

    padding: 30px 24px 40px 24px;
    .title {
      font-size: 30px;
      margin: 10px 0px 40px 0px;
    }
    .line {
      margin-bottom: 30px;
    }
    .content {
      p {
        // font-size: 24px;
        line-height: 30px;
        margin-bottom: 30px;
        line-height: 46px;
      }
    }
  }
}
</style>
